module.exports = __webpack_public_path__ + "static/image/company/m/image_declaration@3x.jpg?2bd33a2a";